import React, { createContext, useContext, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import hr from "./hr.json";
import en from "./en.json";

const DICTS = { hr, en };
export const SUPPORTED = ["hr", "en"];
export const DEFAULT_LANG = "hr";

const I18nContext = createContext({ lang: DEFAULT_LANG, dict: hr, t: (k) => k });

function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export function I18nProvider({ children }) {
  const params = useParams();
  const location = useLocation();

  const lang = useMemo(() => {
    // Force Croatian on /thank_you regardless of prefix
    if (location.pathname.startsWith("/thank_you")) return "hr";
    const p = params.lang;
    if (p && SUPPORTED.includes(p)) return p;
    // Try to parse from path (e.g. /en/privacy)
    const first = location.pathname.split("/").filter(Boolean)[0];
    if (first && SUPPORTED.includes(first)) return first;
    return DEFAULT_LANG;
  }, [params.lang, location.pathname]);

  const dict = DICTS[lang] || DICTS[DEFAULT_LANG];

  const t = (key) => {
    const val = getByPath(dict, key);
    if (val === undefined) return key;
    return val;
  };

  const value = useMemo(() => ({ lang, dict, t }), [lang, dict]); // eslint-disable-line react-hooks/exhaustive-deps

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function langPath(lang, path = "") {
  const clean = path.replace(/^\//, "");
  return `/${lang}${clean ? "/" + clean : ""}`;
}
